import React, { FunctionComponent } from "react";

import { ITestable } from "@/browser";
import { Icon } from "@/components/Icon";

import { ISkillBadgeActionProps, SkillBadge } from "./components";

export interface ISkillAddProps extends ISkillBadgeActionProps, ITestable {
  onClick: () => void;
}

export const SkillAdd: FunctionComponent<ISkillAddProps> = ({ children, onClick, text, testName, ...rest }) => {
  return (
    <SkillBadge {...rest} text={text} onClick={onClick} testName={testName}>
      {children}
      <Icon size="md" icon="add" color="grey2" />
    </SkillBadge>
  );
};
